export { MediaServices } from './MediaServices';
export { _getDebugPlatformInfo } from './helper';



// WEBPACK FOOTER //
// ./src/lib/CameraPhoto/MediaServices/index.js